import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import casesReducer from './slices/casesSlice';
import clientsReducer from './slices/clientsSlice';
import organizationReducer from './slices/organizationSlice';
import chatReducer from './slices/chatSlice';
import reviewsReducer from './slices/reviewSlice';
import newReviewsReducer from './slices/reviewsSlice';
import contactsReducer from './slices/contactsSlice';
import documentsReducer from './slices/documentsSlice';
import firmsReducer from './slices/firmsSlice';
import toastReducer from './slices/toastSlice';
import settingsReducer from './slices/settingsSlice';
import tasksReducer from './slices/tasksSlice';
import { proformasSlice, billsSlice, revenueSlice } from './slices/billingSlice';
import caseEventsReducer from './slices/caseEventsSlice';
import calendarReducer from './slices/calendarSlice';
import reportsReducer from './slices/reportsSlice';
import notificationsReducer from './slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    cases: casesReducer,
    clients: clientsReducer,
    organization: organizationReducer,
    chat: chatReducer,
    reviews: reviewsReducer,
    newReviews: newReviewsReducer,
    contacts: contactsReducer,
    documents: documentsReducer,
    auth: authReducer,
    firms: firmsReducer,
    toast: toastReducer,
    settings: settingsReducer,
    tasks: tasksReducer,
    proformas: proformasSlice.reducer,
    bills: billsSlice.reducer,
    revenue: revenueSlice.reducer,
    caseEvents: caseEventsReducer,
    calendar: calendarReducer,
    reports: reportsReducer,
    notifications: notificationsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
